// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__Ydk6J","content":"not-found_content__-dM0d"};